import { Box, Drawer, Typography } from '@mui/material';
import React from 'react';
import { useModuleDrawerContext } from '../../../../contexts/ModuleDrawerContext';
import { UserConfigurableModule } from '../../../../types/User';
import { moduleDrawerStyles } from './moduleDrawerStyles';
import AccountDrawerView from './modules/AccountDrawerView';
import ContactDrawerView from './modules/ContactDrawerView';
import EmployeeDrawerView from './modules/EmployeeDrawerView';
import EventDrawerView from './modules/EventDrawerView';
import TaskDrawerView from './modules/TaskDrawerView';

const drawerComponents: Partial<Record<UserConfigurableModule, React.FC<{ uuid: string }>>> = {
  [UserConfigurableModule.ACCOUNTS]: AccountDrawerView,
  [UserConfigurableModule.EVENTS]: EventDrawerView,
  [UserConfigurableModule.TASKS]: TaskDrawerView,
  [UserConfigurableModule.CONTACTS]: ContactDrawerView,
  [UserConfigurableModule.EMPLOYEES]: EmployeeDrawerView,
};

export const drawerModulePaths: Partial<Record<UserConfigurableModule, string>> = {
  [UserConfigurableModule.ACCOUNTS]: UserConfigurableModule.ACCOUNTS,
  [UserConfigurableModule.TASKS]: UserConfigurableModule.TASKS,
  [UserConfigurableModule.EVENTS]: UserConfigurableModule.EVENTS,
  [UserConfigurableModule.CONTACTS]: UserConfigurableModule.CONTACTS,
  [UserConfigurableModule.EMPLOYEES]: UserConfigurableModule.EMPLOYEES,
};

const ModuleDrawer: React.FC = () => {
  const { moduleDrawerState, setModuleDrawerState } = useModuleDrawerContext();
  const open = Boolean(moduleDrawerState);

  const handleClose = () => setModuleDrawerState(null);

  const renderContent = () => {
    if (!moduleDrawerState) return null;
    const Component = drawerComponents[moduleDrawerState.module];
    if (!Component) {
      return (
        <Box p={2}>
          <Typography variant="body2">Module not yet supported.</Typography>
        </Box>
      );
    }
    return <Component uuid={moduleDrawerState.uuid} />;
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      variant="temporary"
      sx={moduleDrawerStyles.drawerRoot}
      ModalProps={{
        BackdropProps: {
          sx: { backgroundColor: 'transparent' },
        },
      }}
    >
      <Box sx={moduleDrawerStyles.container}>{renderContent()}</Box>
    </Drawer>
  );
};

export default ModuleDrawer;
